module.exports = __webpack_public_path__ + "img/map.79536e1.png";